import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  getApiShipmentsOptions,
  postApiShipmentsForecast,
  type ForecastShipmentsQuery,
  type GetApiShipmentsError,
  type PageOfShipmentDto,
  type PostApiShipmentsForecastError,
  type ShipmentForecastDto,
} from '@/api';

import { SHIPMENT_FORECAST_KEY } from '../../shipment-actions';
import { toPlanQuery, type ResolvedPlanSearch } from '../lib/searchParams';

/** План отгрузок - отгрузки в «Запланировано» по фильтрам из адресной строки. */
export const usePlannedShipments = (
  resolved: ResolvedPlanSearch,
): UseQueryResult<PageOfShipmentDto, GetApiShipmentsError> =>
  useQuery({
    ...getApiShipmentsOptions({ query: toPlanQuery(resolved) }),
    placeholderData: (previous) => previous,
  });

/**
 * Расчёт плана из истории. На сервере это POST - правки едут телом, - но по сути
 * чтение: ничего не пишет и пересчитывается при каждой правке. Поэтому запрос, а не
 * мутация, и ключ с телом целиком. Прошлый ответ держим на время пересчёта: иначе
 * список мигал бы на каждой правке. null - считать ещё нечего.
 */
export const useShipmentForecast = (
  query: ForecastShipmentsQuery | null,
): UseQueryResult<ShipmentForecastDto, PostApiShipmentsForecastError> =>
  useQuery({
    queryKey: [SHIPMENT_FORECAST_KEY, query],
    queryFn: async ({ signal }) => {
      const { data } = await postApiShipmentsForecast({
        body: query ?? {},
        signal,
        throwOnError: true,
      });

      return data;
    },
    enabled: query !== null,
    placeholderData: (previous) => previous,
  });
